var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticStyle:{"font-size":"12px","font-weight":"600","color":"deepblue"},attrs:{"color":"var(--primary-blue-10)","depressed":""},on:{"click":function($event){return _vm.$emit('click')}}},[_c('mrx-translation',{attrs:{"token":"app.inputs.unknown.button"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }